import Archive from '@/domain/archives/index';
import { getAll } from '@/infra/archives/archivesRepository';

export async function archivesGetAll(): Promise<{
  items: ResolvedArchiveData;
  scrollId: string;
}> {
  try {
    const res = await getAll();
    const data: ResolvedArchiveData = res.items.map(
      (chunk) => new Archive(chunk)
    );
    return { items: data, scrollId: res.scrollId };
  } catch (error: any) {
    if (error.message === 'ServerError') {
      throw error;
    }
    throw error;
  }
}

export default archivesGetAll;

export type ResolvedArchiveData = Archive[];
